import * as api from '@/modules/electronic-operators/api'
import { computed, ref } from 'vue'
import * as types from './types'
export * from './types'

const electronicOperators = ref<api.ElectronicOperatorsResponse>([])
const currentElectronicOperator = ref<types.ElectronicOperatorsListModel>()

const getElectronicOperators = () => api.getElectronicOperators().then(electronicOperatorsList => {
    electronicOperators.value = electronicOperatorsList
})

const getElectronicOperator = async (electronicOperatorId: string) => getElectronicOperators().then(() => {
    currentElectronicOperator.value = electronicOperators.value.find(operator => +operator.id === +electronicOperatorId)
})

const addElectronicOperator = (payload: api.AddElectronicOperatorRequest) => api.addElectronicOperator(payload).then(getElectronicOperators)

const deleteElectronicOperator = (id: string) => api.deleteElectronicOperator(id).then(getElectronicOperators)

export function useElectronicOperatorsModule () {
    return {
        getElectronicOperators,
        electronicOperators: computed(() => electronicOperators.value),
        addElectronicOperator,
        getElectronicOperator,
        currentElectronicOperator: computed(() => currentElectronicOperator.value),
        updateElectronicOperator: api.updateElectronicOperator,
        deleteElectronicOperator
    }
}
